import React from 'react';
import Wahanda from 'common/wahanda';
import ItemRowView from '../summary-view/item-row';
import { QuotesSummary as QuotesSummaryType } from 'reduxStore/common/dailyReport/types';

type QuotesSummaryProps = {
  quotesSummary?: QuotesSummaryType;
};

export const QuotesSummary = ({ quotesSummary }: QuotesSummaryProps) => {
  if (!quotesSummary) {
    return null;
  }

  const quotesSummaryLang = Wahanda.lang.reports.transactions.daySummary.quotesSummary;

  return (
    <div className="cash-summary">
      <div className="item important">{quotesSummaryLang.heading}</div>
      <div className="item-container">
        <div className="item-group">
          <ItemRowView
            title={quotesSummaryLang.total}
            amount={quotesSummary.totalGrossAmount}
            additionalClass="grey total"
          />
        </div>
      </div>
    </div>
  );
};
